import axios from '@/services/axios'

const fetchHolidaysData = async (
	data: FilterPayload,
): Promise<{ data: Holiday[]; pagination: Pagination }> => {
	const queryParams = new URLSearchParams()
	queryParams.append('page', data.pageNumber)
	queryParams.append('limit', data.pageSize)

	if (data.filterColumn && data.filterValue) {
		queryParams.append('filterColumn', data.filterColumn)
		queryParams.append('filterValue', data.filterValue)
	}

	const queryString = queryParams.toString()

	const response = await axios.get(`/holidays?${queryString}`)
	return response.data
}

const fetchAllHolidays = async (): Promise<{ data: Holiday[]; pagination: Pagination }> => {
	const response = await axios.get('/holidays')
	return response.data
}

const createHoliday = async (data: { holiday_date: Date }) => {
	const response = await axios.post('/holidays', data)
	return response.data
}

const updateHoliday = async (id: Holiday['id'], data: { holiday_date: Date }) => {
	const response = await axios.put(`/holidays/${id}`, data)
	return response.data
}

const deleteHoliday = async (id: Holiday['id']) => {
	const response = await axios.delete(`/holidays/${id}`)
	return response.data
}

const holidayService = {
	fetchHolidaysData,
	fetchAllHolidays,
	createHoliday,
	updateHoliday,
	deleteHoliday,
}

export default holidayService
